import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCdoPkhszBdR-7e1HkIkjEmHEv5Wrwa8Qs",
  authDomain: "qr-reward-b29b3.firebaseapp.com",
  projectId: "qr-reward-b29b3",
  storageBucket: "qr-reward-b29b3.firebasestorage.app",
  messagingSenderId: "1001241532950",
  appId: "1:1001241532950:web:d6284486fb50d509403337",
  measurementId: "G-RJEE8RH698"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, auth, db, storage, firebaseConfig };
